import { UPDATE_TASK, UPDATE_TASK_SUCCESSFUL, UPDATE_TASK_FAILED } from "./actionTypes";

// export const updateTask = (task,token, username,history) => {
//     return {
//         type: UPDATE_TASK,
//         payload: { task,token,username, history }
//     }
// }

export const updateTask = (task, token, history) => {
  return {
    type: UPDATE_TASK,
    payload: { task, token, history },
  };
};

export const updateTaskSuccessful = (msg) => {
  return {
    type: UPDATE_TASK_SUCCESSFUL,
    payload: msg,
  };
};

export const updateTaskFailed = (msg) => {
  return {
    type: UPDATE_TASK_FAILED,
    payload: msg,
  };
};
